/**
 * @file: ListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */
import ListModel from '../../common/FrameListModel';

export default class Model extends ListModel {
    pageType = '中间页';

    init() {
        super.init();
        this.trendRequester = this.api.statsFrameTrend;
        this.downloadApi = this.api.statsFrameListDownload;
        this.listRequester = this.api.statsFrameList;
    }
}
